import axios from "axios";
import { useEffect } from "react";
import Icon, { ICONS } from "@/components/Core/Icons";
import { useSession, useUser } from "@clerk/clerk-react";
import { useUserId } from "@/utils/utils";

interface Props {
  port?: number;
  successMessage?: string;
}

const LocalLoginPage = (props: Props) => {
  const { session } = useSession();
  const userId = useUserId();
  const port = props.port || 2994;
  const successMessage =
    props.successMessage ||
    "You are now logged in, please return to terminal...";

  // Send the access token to the extension server
  // This port has to match the port the extension runs its server on
  // TODO: What if this port is taken?
  useEffect(() => {
    if (!session || !userId) {
      return;
    }

    session
      // Token with a TTL of 7 days
      //   Prod Template: https://dashboard.clerk.com/apps/app_2vBkXDGrfao0lSMcOlYyKbr5shX/instances/ins_2vXaYcjNa5JuccinqPUDNJcNv4r/jwt-templates/jtmp_2vjcGrLuvbfDNgfqR3wST7R9TID
      //   Dev Template: https://dashboard.clerk.com/apps/app_2vBkXDGrfao0lSMcOlYyKbr5shX/instances/ins_2vBkX7XNVZDnEHQrfgaaxetEDBe/jwt-templates/jtmp_2vjczYLt70Z9JV2Gr8uYyJb7Jn3
      ?.getToken({ template: "tempo-local" })
      .then((supabaseJWT: string) => {
        // Debug: Check JWT expiration
        try {
          const tokenParts = supabaseJWT.split(".");
          if (tokenParts.length === 3) {
            const payload = JSON.parse(atob(tokenParts[1]));
            const expirationTime = payload.exp * 1000;
            const currentTime = Date.now();
            const timeUntilExpiration = expirationTime - currentTime;
            const minutesUntilExpiration = Math.floor(
              timeUntilExpiration / (1000 * 60),
            );

            console.log("JWT Debug - Token issued for extension:");
            console.log("  Current time:", new Date(currentTime).toISOString());
            console.log(
              "  Token expires:",
              new Date(expirationTime).toISOString(),
            );
            console.log("  Minutes until expiration:", minutesUntilExpiration);
            console.log("  Token payload:", {
              exp: payload.exp,
              iat: payload.iat,
              iss: payload.iss,
            });
          }
        } catch (e) {
          console.error("Failed to decode JWT for debugging:", e);
        }

        axios
          .post(
            `http://localhost:${port}/tempo/auth`,
            {
              authId: userId,
            },
            {
              headers: {
                Authorization: `Bearer ${supabaseJWT}`,
              },
            },
          )
          .catch((e) => {
            console.error(e);
          });
      });
  }, [Boolean(session), userId]);

  return (
    <div>
      <h1
        style={{
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="flex items-center justify-center flex-col text-xl mt-8">
          <div>{successMessage}</div>
        </div>
      </h1>
    </div>
  );
};

export default LocalLoginPage;
